// inlineEditSession — chat-scoped "edit this image with the chatbot" session,
// started from the Image Animator modal's top-bar button.
//
// Lives OUTSIDE React because each `editImage` tool-UI card mounts on its own
// chat turn, yet they must all share one working image: every edit chains on
// the PREVIOUS preview (never the canvas), and the canvas image is only touched
// when the user clicks "Uygula". A module-level store + pub-sub gives every
// card the current working URL without threading props through the runtime.
//
// Shape: { boxId, navId, workingUrl } | null

let session = null;
const listeners = new Set();

function emit() {
  listeners.forEach((fn) => {
    try {
      fn(session);
    } catch {
      /* a bad listener must not break the others */
    }
  });
}

// Begin a fresh session (overwrites any lingering one). No-op without a URL.
export function startInlineEditSession({ boxId, navId, workingUrl } = {}) {
  if (!workingUrl) return;
  session = { boxId: boxId || null, navId: navId || null, workingUrl };
  emit();
}

export function getInlineEditSession() {
  return session;
}

export function isInlineEditActive() {
  return !!session;
}

// Advance the working image to an edit result so the NEXT edit chains on it.
// `jobId` (optional) is the edit job that produced it: every job in the chain
// fed the image that finally gets applied, so all of them are approved then.
export function setInlineWorkingUrl(url, jobId) {
  if (!session || !url) return;
  session = {
    ...session,
    workingUrl: url,
    jobIds: jobId ? [...(session.jobIds || []), jobId] : session.jobIds || [],
  };
  emit();
}

export function clearInlineEditSession() {
  session = null;
  emit();
}

export function subscribeInlineEditSession(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}
